<template>
  <div>
    <v-app-bar flat color="white" class="x-scroll">
      <div class="pa-2">
        <v-btn class="gray font-weight-bold" @click="onBack"
          ><v-icon left>mdi-arrow-left-circle</v-icon>戻る</v-btn
        >
      </div>
      <div class="pa-2">
        <agency-contact-dialog-component
          ref="refDialogComponent"
          :agency_id="agency_id"
          @updated="updated"
        ></agency-contact-dialog-component>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import agencyContactDialogComponent from "./component/agencyContactDialogComponent.vue";

export default {
  components: {
    agencyContactDialogComponent,
  },
  props: ["agency_id"],
  setup(props, ctx) {
    const refDialogComponent = ref(null);

    // app-barにあるコンポーネント呼び出し
    const action = (params) => {
      switch (params.action) {
        case "edit":
          refDialogComponent.value.editDialog(params.value);
          break;
      }
    };

    const onBack = async () => {
      ctx.emit("on_back");
    };

    const updated = (agency_contact_data) => {
      ctx.emit("updated", agency_contact_data);
    };

    return {
      refDialogComponent,
      action,
      onBack,
      updated,
    };
  },
};
</script>
